import {NgModule} from '@angular/core';
import {AoUpsellComponent} from "./ao-upsell.component";
import {SharedModule} from "../../../shared.module";

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [AoUpsellComponent],
    exports: [AoUpsellComponent]
})
export class AoUpsellModule {}
